<script setup lang="ts">
import { EigentuemerschaftCollection } from '@/models/Eigentuemerschaft'
import { onMounted, ref, type Ref } from 'vue'

const modelValue = defineModel<string | null>()

const {
    dense = false,
    label = '',
    rules = [],
} = defineProps<{
    dense?: boolean
    label?: string
    rules?: string[]
}>()

const loading = ref(false)
const eigentuemerschaften: Ref<string[]> = ref([])
const collection = new EigentuemerschaftCollection()

onMounted(() => {
    load()
})

async function load() {
    loading.value = true
    try {
        await collection.query()
        eigentuemerschaften.value = collection.getModels().map((a) => a.bezeichnung || '')
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <div class="text-subtitle-1 text-medium-emphasis">{{ label }}</div>
    <v-combobox
        class="inputfield"
        v-model:model-value="modelValue"
        :items="eigentuemerschaften ? eigentuemerschaften : []"
        item-text="bezeichnung"
        item-value="bezeichnung"
        :dense="dense"
        :loading="loading"
        :rules="rules"
        hide-selected
    ></v-combobox>
</template>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
</style>
